/**
 * Parsing function to be used in the pipe of getSections. An endmark is whatever logo NBC wants
 * to see at the end of an article. Since later pipes of getSections() insert additional non-article
 * content to the body, we require this function to ensure the endmark gets placed in the right
 * position.
 *
 * @param {articleItems[]} articleContent Previously parsed article items array from getSections()
 */
export const insertEndmark = (articleContent = []) => {
  for (let x = articleContent.length - 1; x >= 0; x -= 1) {
    const item = articleContent[x] || {};

    if (item && item.type === 'markup' && (item.element === 'p' || item.element === 'ul')) {
      item.insertEndmark = true;
      break;
    }
  }

  return articleContent;
};
